import { useCallback } from "react";
import { EvServiceInstallationData } from "generated/graphql";

const useFilteredInstallationData = () => {
  const filterChecked = useCallback(
    <T extends { isChecked?: boolean; isTemplate?: boolean }>(
      items: T[],
    ): Omit<T, "isTemplate">[] => {
      return items
        .filter((item) => item.isChecked === true && !item.isTemplate)
        .map(({ isTemplate: _, ...rest }) => rest as Omit<T, "isTemplate">);
    },
    [],
  );

  const filterInstallationData = useCallback(
    (data: EvServiceInstallationData): EvServiceInstallationData => {
      return {
        serviceOfferingSetup: {
          ...data.serviceOfferingSetup,
          supportedEVSETypes: filterChecked(
            data.serviceOfferingSetup.supportedEVSETypes,
          ),
          buildingServiced: filterChecked(
            data.serviceOfferingSetup.buildingServiced,
          ),
        },

        chargerConfig: {
          ...data.chargerConfig,
          evseType: filterChecked(data.chargerConfig.evseType),
        },

        installationConfig: {
          ...data.installationConfig,
          cableLength: filterChecked(data.installationConfig.cableLength),
          inclusions: filterChecked(data.installationConfig.inclusions),
          addOnServices: filterChecked(data.installationConfig.addOnServices),
        },

        paymentAndAssumptionsConfigData: {
          ...data.paymentAndAssumptionsConfigData,
          paymentTypes: filterChecked(
            data.paymentAndAssumptionsConfigData.paymentTypes,
          ),
          assumptions: filterChecked(
            data.paymentAndAssumptionsConfigData.assumptions,
          ),
        },
      };
    },
    [filterChecked],
  );

  return { filterInstallationData };
};

export default useFilteredInstallationData;
